import React from 'react';
import { connect } from 'react-redux';
import { Timelines } from '../menus/Timelines';
import { AudioEditorControls } from '../../audioEditor/menus/AudioEditorControls';
import properties from '../../../constants/Properties';
import storeManager from '../../../store/StoreManager';
import { hideMenus } from '../../../actions/MenuActions';
import mouseUtils from '../../utils/MouseUtils';
import menuType from '../../../constants/MenuType';
import platformDetection from '../../utils/PlatformDetection';
import audioToolUtils from '../utils/AudioToolUtils';
import apiServiceUtils from '../../utils/ApiServiceUtils';
import audioEditorUtils from '../../audioEditor/utils/AudioEditorUtils';

export const AudioTimelineComponentWrapper = React.createClass({
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.props.dispatch(hideMenus([menuType.ALL_MENUS]));
    },
    render() {
        const width = this.props.windowWidth - this.props.accordionWidth;
        var listHeight = this.props.windowHeight - audioToolUtils.headerHeight() - properties.SLIDE_VIEWER_BOTTOM_GAP;
        var timelinesListHeight = listHeight;
        var minimumTimelineHeight = audioEditorUtils.getAudioEditorHeight() + properties.SLIDE_VIEWER_BOTTOM_GAP + 20;

        if (listHeight < minimumTimelineHeight)
            timelinesListHeight = minimumTimelineHeight;

        const height = listHeight + properties.SLIDE_VIEWER_BOTTOM_GAP;
        var topBarHeight = 0;

        if (platformDetection.isIOSApp())
            topBarHeight = properties.CLIPART_BUTTON_HEIGHT_OLD;

        topBarHeight = topBarHeight + apiServiceUtils.getNoInternetConnectionAlertHeight();

        var slideViewerStyle = {
            position: 'absolute',
            top: audioToolUtils.headerHeight() + topBarHeight,
            left: 0,
            width: width,
            height: height,
            background: properties.SLIDE_VIEWER_BACKGROUND,
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none',
            overflowX: 'hidden',
            overflowY: 'auto'
        };

        return (
            <div ref="slideViewerWrapper" style={slideViewerStyle} onMouseDown={this.onClick} onTouchEnd={this.onClick}>
                <Timelines buttonsHolderWidth={this.props.buttonsHolderWidth} listHeight={timelinesListHeight} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight}/>
                <AudioEditorControls buttonsHolderWidth={this.props.buttonsHolderWidth} dispatch={this.props.dispatch} windowHeight={this.props.windowHeight}/>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const timelines = state.audioEditor.timelines;
    const undo = state.undoRedo.undo;
    const redo = state.undoRedo.redo;
    var accordionWidth = state.accordion.width;
    const contextMode = state.menu.contextMode;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    return {
        undo,
        redo,
        accordionWidth,
        contextMode,
        timelines
    };
}

export const AudioTimelineComponent = connect(mapStateToProps)(AudioTimelineComponentWrapper);



/** WEBPACK FOOTER **
 ** ./src/components/audioTool/menus/AudioTimelineComponent.js
 **/